import { render, staticRenderFns } from "./proPost.vue?vue&type=template&id=225ae212&scoped=true&"
import script from "./proPost.vue?vue&type=script&lang=js&"
export * from "./proPost.vue?vue&type=script&lang=js&"
import style0 from "./proPost.vue?vue&type=style&index=0&id=225ae212&scoped=true&lang=css&"
import style1 from "./proPost.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ae212",
  null
  
)

export default component.exports